import IconBox from '@/components/iconBox';
import CustomSelectCompany from '@/modules/company/components/customSelectCompany/customSelectCompany';
import { Company } from '@/modules/company/entities/interfaces/company';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import ICONS from '@/shared/entities/constants/icons';
import storage from '@/utils/storage/storage';
import React, { useEffect } from 'react';
import { Text } from 'vkit/lib/components';
import { Box, Grid, Row } from 'vkit/lib/context';

interface RecentCompaniesProps {
  onClick: (company: Company) => void;
}

const RecentCompanies: React.FC<RecentCompaniesProps> = ({ onClick }) => {
  const { user } = useCurrentUser();
  const { isBrokerUser } = useCurrentUser();

  const filterValidRecentCompanies = (company: Company) => {
    const fiedlKeys: Partial<keyof Company>[] = [
      'id',
      'name',
      'companyGroupId',
      'salesforceId',
      'status',
      'billing'
    ];

    return fiedlKeys.every(
      (fieldKey) =>
        company[fieldKey] !== undefined && company[fieldKey] !== null && company[fieldKey] !== '',
    );
  };

  const recentCompanies = (storage.get<Company[]>(`${user.id}.recentCompanies`) ?? []).filter(filterValidRecentCompanies);

  useEffect(() => {
    storage.set(`${user.id}.recentCompanies`, recentCompanies);
  }, [recentCompanies, user.id]);

  return recentCompanies?.length ? (
    <Grid column gap={16} stretch>
      <Text value='Recentes' size='medium' />
      {recentCompanies.map((recentCompany) => (
        <Box key={recentCompany.id} rounded type='sheet' onClick={() => onClick(recentCompany)}>
          <Row>
            <Grid row alignItems='center' gap={16}>
              <IconBox icon={ICONS.COMPANY} size={40} />
              <CustomSelectCompany showCompanyStatus={isBrokerUser} option={recentCompany} />
            </Grid>
          </Row>
        </Box>
      ))}
    </Grid>
  ) : null;
};

export default RecentCompanies;
